/* Progressive enhancement for CLOWN's Shopify theme. No global fetch override. */
(() => {
  'use strict';
  if (window.__clownRefonte) return;
  window.__clownRefonte = true;
  const root = window.Shopify?.routes?.root || '/';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Dessin de Baggy : vidéo transparente (HEVC alpha pour Safari / iOS, WebM VP9 alpha ailleurs), l'ancienne vidéo + fusion en secours.
  const crDrawingSrc = video => {
    const apple = navigator.vendor === 'Apple Computer, Inc.';
    const alpha = apple ? video.dataset.srcHevc : video.dataset.srcWebm;
    if (alpha) { video.classList.add('is-alpha'); return alpha; }
    return video.dataset.src;
  };
  let menu = document.querySelector('[data-cr-menu]');
  let menuTrigger;
  function closeMenu() {
    if (!menu?.open) return;
    menu.close();
    document.body.classList.remove('cr-menu-open');
    menuTrigger?.setAttribute('aria-expanded', 'false');
    menuTrigger?.focus();
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cr-menu-open]');
    if (opener && menu) {
      menuTrigger = opener;
      menu.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('cr-menu-open');
      menu.querySelector('[data-cr-menu-close]')?.focus();
    }
    if (event.target.closest('[data-cr-menu-close]')) closeMenu();
    document.querySelectorAll('[data-cr-dropdown][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-cr-dropdown][open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });

  function initialize(scope = document) {
    menu = document.querySelector('[data-cr-menu]');
    if (menu && !menu.dataset.crMenuReady) {
      menu.dataset.crMenuReady = 'true';
      menu.addEventListener('cancel', event => { event.preventDefault(); closeMenu(); });
      menu.addEventListener('click', event => { if (event.target.closest('a')) closeMenu(); });
    }
    scope.querySelectorAll('[data-cr-carousel]').forEach(carousel => {
      if (carousel.dataset.crReady) return;
      carousel.dataset.crReady = 'true';
      const track = carousel.querySelector('[data-cr-track]');
      if (!track) return;
      const previous = carousel.querySelector('[data-cr-prev]');
      const next = carousel.querySelector('[data-cr-next]');
      const sync = () => {
        if (previous) previous.disabled = track.scrollLeft < 2;
        if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const scroll = direction => {
        const card = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: reduced.matches ? 'instant' : 'smooth' });
      };
      previous?.addEventListener('click', () => scroll(-1));
      next?.addEventListener('click', () => scroll(1));
      carousel.addEventListener('keydown', event => {
        if (event.target !== carousel || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); scroll(event.key === 'ArrowRight' ? 1 : -1);
      });
      track.addEventListener('scroll', sync, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(sync).observe(track);
      sync();
    });
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (entry.target.getBoundingClientRect().top < 80) return;
          entry.target.animate([{ opacity: .3, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 600, easing: 'cubic-bezier(.22,.61,.36,1)' });
        });
      }, { threshold: .12 });
      scope.querySelectorAll('.cr-reveal').forEach(element => {
        if (element.dataset.crRevealed) return;
        element.dataset.crRevealed = 'true'; observer.observe(element);
      });
    }
    scope.querySelectorAll('[data-cr-drawing]').forEach(video => {
      if (video.dataset.crReady) return;
      video.dataset.crReady = 'true';
      const container = video.parentElement;
      const poster = container.querySelector('[data-cr-drawing-poster]');
      let started = false;
      const play = async () => {
        if (reduced.matches) return;
        if (!video.src) video.src = crDrawingSrc(video);
        video.muted = true;
        try {
          await video.play();
          video.hidden = false;
          if (poster) poster.hidden = true;
          started = true;
        } catch (_) { /* The still illustration remains visible if playback is blocked. */ }
      };
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { if (!started || (video.paused && !video.ended)) play(); }
          else if (!video.paused) video.pause();
        }), { threshold: .35 }).observe(video.parentElement);
      }
      reduced.addEventListener('change', () => {
        if (reduced.matches) { video.pause(); video.hidden = true; if (poster) poster.hidden = false; }
      });
    });
    // Vidéos en boucle sous la ligne de flottaison (17.10.2026) : téléchargées et lancées
    // seulement à l'approche de l'écran, pour ne pas concurrencer la photo du haut de page.
    scope.querySelectorAll('video[data-cr-lazy-video]').forEach(video => {
      if (video.dataset.crReady) return;
      video.dataset.crReady = 'true';
      if (reduced.matches || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) video.play().catch(() => { /* L'affiche reste visible. */ });
        else if (!video.paused) video.pause();
      }), { rootMargin: '200px 0px' }).observe(video);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));

  // Cartes produit : « Ajouter au panier » direct (snippet clown-r-quick-add). Le tiroir s'ouvre via clown:cart:add.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cr-quick-add]');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-cr-qa-label]');
    const status = button.parentElement.querySelector('[data-cr-qa-status]');
    const original = label ? label.textContent : '';
    if (status) status.textContent = '';
    if (label) label.textContent = window.clownI18n.message_0;
    document.dispatchEvent(new CustomEvent('clown:cart:add', { detail: {
      items: [{ id: Number(button.dataset.variant), quantity: 1 }], button,
      onSuccess: () => { if (label) { label.textContent = window.clownI18n.message_2; setTimeout(() => { label.textContent = original; }, 1800); } },
      onError: error => { if (label) label.textContent = original; if (status) status.textContent = error?.description || error?.message || window.clownI18n.message_4; },
    } }));
  });

  // Panier : « Souvent ajouté · Duo créatif » ajoute un 2e Kit Créatif Complet (le tiroir est re-rendu, d'où la délégation).
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cr-cart-duo-btn]');
    if (!button) return;
    const status = button.parentElement.querySelector('[data-cr-cart-duo-status]');
    if (status) status.textContent = '';
    document.dispatchEvent(new CustomEvent('clown:cart:add', { detail: {
      items: [{ id: Number(button.dataset.variant), quantity: 1 }], button,
      onError: error => { if (status) status.textContent = error?.description || error?.message || window.clownI18n.message_4; },
    } }));
  });

  // Panier vide : le dessin de Baggy tourne en boucle tant que le tiroir est ouvert (contenu re-rendu à chaque mise à jour).
  {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      const sync = () => {
        const video = drawer.querySelector('[data-cr-cart-drawing] video');
        if (!video) return;
        const open = drawer.classList.contains('active') && !reduced.matches;
        if (!open) { if (!video.paused) video.pause(); return; }
        if (!video.paused) return;
        if (!video.src) video.src = crDrawingSrc(video);
        video.muted = true;
        video.play().then(() => {
          video.hidden = false;
          video.parentElement.querySelector('img')?.setAttribute('hidden', '');
        }).catch(() => { /* l'illustration fixe reste visible */ });
      };
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
  }

  // En-tête collant : ombre et logo réduit dès que la barre touche le haut de l'écran.
  {
    let ticking = false;
    const stick = () => {
      ticking = false;
      const header = document.querySelector('[data-cr-header]');
      if (header) header.classList.toggle('is-stuck', scrollY > 0 && header.getBoundingClientRect().top <= 0);
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(stick); } }, { passive: true });
    stick();
  }

  // Serialized cart mutations: one click = one request, even across multiple purchase blocks.
  let cartQueue = Promise.resolve();
  function status(message) {
    let element = document.querySelector('[data-cr-cart-status]');
    if (!element) {
      element = document.createElement('p'); element.className = 'cr-cart-status';
      element.dataset.crCartStatus = ''; element.setAttribute('role', 'status');
      element.setAttribute('aria-live', 'polite'); document.body.append(element);
    }
    element.textContent = message;
  }
  async function renderCart(data, button) {
    let sections = data.sections;
    const wanted = ['cart-drawer', 'cart-icon-bubble'];
    if (!sections || wanted.some(key => !sections[key])) {
      const url = new URL(location.href); url.searchParams.set('sections', wanted.join(','));
      const response = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error(window.clownI18n.message_7);
      sections = await response.json();
    }
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || wanted.some(key => !sections[key])) throw new Error(window.clownI18n.message_7);
    const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    drawer.classList.toggle('is-empty', !!parsed.querySelector('cart-drawer.is-empty'));
    drawer.setActiveElement?.(button);
    drawer.renderContents({ ...data, sections });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'clown-refonte', cartData: { ...data, sections } });
  }
  document.addEventListener('clown:cart:add', event => {
    const detail = event.detail || {};
    const button = detail.button;
    if (button?.dataset.crAdding === 'true') return;
    const items = (detail.items || []).map(item => ({ ...item, id: Number(item.id), quantity: Number(item.quantity || 1) }));
    if (!items.length || items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isInteger(item.quantity) || item.quantity < 1)) {
      const error = new Error(window.clownI18n.message_8);
      detail.onError?.(error); status(error.message); return;
    }
    if (button) { button.dataset.crAdding = 'true'; button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    status('');
    cartQueue = cartQueue.catch(() => {}).then(async () => {
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname + location.search }),
        });
        // Shopify can return HTML during a temporary rate limit or service error.
        // Never expose a JSON parser error or retry a purchase automatically.
        const data = await response.json().catch(() => null);
        if (!data || !response.ok || data.status) {
          const message = response.status === 429
            ? window.clownI18n.message_9
            : data?.description || data?.message || window.clownI18n.message_5;
          throw new Error(message);
        }
        // An API success must never be reported as an add failure: a retry would duplicate the purchase.
        try { await renderCart(data, button); }
        catch (_) { status(window.clownI18n.message_10); }
        detail.onSuccess?.(data);
        document.dispatchEvent(new CustomEvent('clown:cart:added', { detail: { ...detail, data } }));
      } catch (error) {
        status(error.message || window.clownI18n.message_5);
        detail.onError?.(error);
        document.dispatchEvent(new CustomEvent('clown:cart:error', { detail: { ...detail, error } }));
      } finally {
        if (button) { delete button.dataset.crAdding; button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    });
  });
})();
